import { styled } from 'styled-components';
import { MediaQuery, Theme } from '@pelando/components';

type BannerImageProps = {
  $mobileBannerImage: string;
  $desktopBannerImage: string;
};

export const BannerImage = styled.div<BannerImageProps>`
  width: 767px;
  height: 186px;
  z-index: -1;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url(${({ $mobileBannerImage }) => $mobileBannerImage});
  background-color: rgb(${Theme.colors.Brand});

  @media ${MediaQuery.SCREEN_MD_UP} {
    width: 600px;
    height: 222px;
    background-image: url(${({ $desktopBannerImage }) => $desktopBannerImage});
  }
`;

export const ModalTitleWrapper = styled.div`
  strong {
    color: rgb(${Theme.colors.Brand});
  }
`;
